import { jsx as _jsx } from "react/jsx-runtime";
import axios from 'axios';
import { createContext, useEffect, useMemo, useState } from 'react';
import { useMatch } from 'react-router-dom';
import { Spinner } from 'libs.nucleus';
import { getUseLocalCortextSessionStorageKey } from '../../helpers/local_storage.helpers';
import { isChinaCluster } from '../../helpers/study.helpers';
import { useCurrentEnvironment } from '../../hooks/use_current_environment';
export const CortexSessionHandlerContext = createContext({
    cortexSessionHandlerCalled: false,
    cortexSessionData: null,
});
export const CortexSessionHandlerProvider = ({ children }) => {
    const match = useMatch('/site/study/:studyId/*');
    const studyId = match?.params?.studyId;
    const { environment } = useCurrentEnvironment(studyId);
    const [cortexSessionHandlerCalled, setCortexSessionHandlerCalled] = useState(false);
    const [cortexSessionData, setCortexSessionData] = useState(null);
    const callCortexSessionHandler = async () => {
        if (!environment) {
            return;
        }
        try {
            const iamEndpoint = process.env.IAM_SERVICE_ENDPOINT;
            const url = `${iamEndpoint}/v1/sso/token?aud=${environment.cortexURL}/${environment.code}`;
            const response = await axios.get(url, {
                withCredentials: true,
            });
            setCortexSessionData(response.data);
        }
        catch (error) {
            console.log('error', error);
        }
    };
    const initCortexSessionHandler = async () => {
        const chinaCluster = isChinaCluster(environment);
        const useLocalCortexSession = localStorage.getItem(getUseLocalCortextSessionStorageKey());
        // If we are in a china cluster environment, we need to call the cortex session handler to log us into the china org
        // If we are not in a china cluster environment, we proceed as normal
        if (chinaCluster || useLocalCortexSession) {
            await callCortexSessionHandler();
        }
        setCortexSessionHandlerCalled(true);
    };
    useEffect(() => {
        if (environment) {
            initCortexSessionHandler();
        }
    }, [environment]);
    const value = useMemo(() => ({
        cortexSessionHandlerCalled,
        cortexSessionData,
    }), [cortexSessionHandlerCalled, cortexSessionData]);
    if ((studyId && !cortexSessionHandlerCalled) || (isChinaCluster(environment) && !cortexSessionData)) {
        return _jsx(Spinner, { wrapper: 'full' });
    }
    return _jsx(CortexSessionHandlerContext.Provider, { value: value, children: children });
};
